/* eslint-disable react/jsx-child-element-spacing */
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { Avatar, Divider, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useState } from 'react'
import Confetti from 'react-confetti'
import { useLocation } from 'react-router-dom'

import DialogDrawer from 'src/components/pages/SmartLink/DialogDrawer/DialogDrawer'
import SignUpForm from 'src/components/pages/SmartLink/SignUp/SignUpForm'
import SubscribeModal from 'src/components/pages/SmartLink/SubscribeModal/SubscribeModal'
import type { MarketingLink } from 'src/models/Marketing'
import type { BasicOrganisation } from 'src/models/Organisation'
import * as darkTheme from 'src/styles/dark.theme'
import * as lightTheme from 'src/styles/light.theme'

type Props = {
  readonly close: () => void
  readonly open: boolean
  readonly link: MarketingLink | undefined
  readonly onOpen: () => void
  readonly organisation: BasicOrganisation
}

const PresaveModal = (props: Props) => {
  const [openSubscribe, setOpenSubscribe] = useState(false)
  const height = window.innerHeight
  const width = window.innerWidth

  const activeTheme = props.link?.palette === 'Dark'
    ? darkTheme
    : lightTheme

  const themeItem = useTheme()
  const fullScreen = useMediaQuery(themeItem.breakpoints.down('md'))

  const search = useLocation().search
  const platform = new URLSearchParams(search).get('platform')
  const platformPrettyString = platform === 'spotify'
    ? 'Spotify'
    : platform === 'amazon'
      ? 'Amazon Music'
      : platform === 'deezer'
        ? 'Deezer'
        : platform === 'apple'
          ? 'Apple Music'
          : 'Unknown'

  return (
    <>
      <Confetti
        height={height}
        numberOfPieces={280}
        recycle={false}
        width={width}
      />
      <SubscribeModal
        close={() => setOpenSubscribe(false)}
        link={props.link}
        open={openSubscribe}
        openDrawer={() => setOpenSubscribe(true)}
        organisation={props.organisation}
      />
      <DialogDrawer
        close={props.close}
        isOpen={props.open}
        link={props.link}
        open={props.onOpen}
      >
        <Stack paddingX={2} paddingY={2} spacing={2} width={1}>
          {!fullScreen &&
          <Stack alignItems='center' direction='row' justifyContent='space-between' width={1}>
            <Typography
              color={activeTheme.default.palette.text.primary}
              textAlign='center'
              variant='h3'
            >
              Complete
            </Typography>
            <IconButton
              onClick={() => props.close()}
              sx={{
                width: 'fit-content',
              }}
            >
              <CloseRoundedIcon />
            </IconButton>
          </Stack>}
          <Stack alignItems='center' justifyContent='center' spacing={2} width='100%'>
            <Avatar
              src={props.link?.artworkUrl}
              sx={{
                height: 96,
                width: 96,
                borderRadius: '16px',
              }}
            />
            <Typography
              lineHeight={1.2}
              sx={{
                color: activeTheme.default.palette.text.primary,
                textAlign: 'center',
              }}
              variant='h4'
            >
              {'You have successfully Pre-saved '}
              {props.link?.title}
            </Typography>
            <Divider sx={{ borderColor: activeTheme.default.palette.divider, width: '100%' }} />
            <Stack width={1}>
              <Typography
                lineHeight={1.2}
                sx={{
                  color: activeTheme.default.palette.text.primary,
                }}
                textAlign='center'
                variant='body1'
              >
                Get notified about exclusive content, events, and more
              </Typography>
              <SignUpForm
                event='Presave'
                link={props.link}
                organisation={props.organisation}
                platform={platformPrettyString}
              />
            </Stack>
          </Stack>
        </Stack>
      </DialogDrawer>
    </>
  )
}

export default PresaveModal
